import React from 'react';

export const sceneTwoMeta = {
  id: 'great-tree',
  title: '場景二｜看一棵參天大樹',
  excerpt: '任何小樹都有機會長成參天大樹，差別在土壤、扎根、失敗與時間。',
};

const SceneTwoGreatTree: React.FC = () => (
  <article className="forest-article-detail">
    <h2>{sceneTwoMeta.title}</h2>
    <p>任何一棵小樹，都有機會長成參天大樹。</p>
    <p>差別不在大小，而在於：有沒有落在對的土壤，有沒有持續向下扎根、向上生長。</p>
    <p>熱愛，是種子。</p>
    <p>環境與產業鏈，是土壤。</p>
    <p>一次次失敗，是養分與肥料。</p>
    <p>而時間，則是陽光與四季。</p>
    <p>真正的成功，從來不是一夜爆紅。</p>
    <p>而是在沒有人看見時，依然默默生長；在風吹雨打後，依然不放棄扎根。</p>
    <blockquote>因為所有參天大樹，都曾經只是一棵不起眼的小樹苗。</blockquote>
  </article>
);

export default SceneTwoGreatTree;
